export default __webpack_public_path__ + "locales/nl/InviteDialog.json?hash=985962f52282557cbcc8434f7afaedc6";